import { useEffect, useState } from "react"
import { UseFormReturn } from "react-hook-form"
import { McpCapabilityConfigSchema, TestMcpResponseSchema } from "schema"
import { z } from "zod"
import { CampaignActivationAccordion } from "./Shared/CampaignActivationAccordion"
import { GeneralSection } from "./Shared/GeneralSection"
import { MCPServerAccordion } from "./Shared/MCPServerAccordion"
import { MCPToolsAccordion } from "./Shared/MCPToolsAccordion"

type MCPCapabilityFormType = z.infer<typeof McpCapabilityConfigSchema>
type DiscoveredTool = z.infer<typeof TestMcpResponseSchema>["tools"][number]

interface MCPCapabilityFormProps {
  form: UseFormReturn<MCPCapabilityFormType>
  activationSettings?: React.ReactNode
  isLoading: boolean
  discoveredTools?: DiscoveredTool[]
  onToolsDiscovered?: (tools: DiscoveredTool[]) => void
}

export default function MCPCapabilityForm({
  form,
  activationSettings,
  isLoading,
  discoveredTools = [],
  onToolsDiscovered,
}: MCPCapabilityFormProps) {
  const formTools = form.watch("tools")
  const [localDiscoveredTools, setLocalDiscoveredTools] = useState<DiscoveredTool[]>(
    formTools || discoveredTools,
  )

  useEffect(() => {
    if (formTools && formTools.length > 0) {
      setLocalDiscoveredTools(formTools)
    }
  }, [formTools])

  const handleToolsDiscovered = (tools: DiscoveredTool[]) => {
    setLocalDiscoveredTools(tools)
    if (onToolsDiscovered) {
      onToolsDiscovered(tools)
    }
  }

  const handleTestStart = () => {
    setLocalDiscoveredTools([])
  }

  return (
    <>
      <GeneralSection form={form} translationPrefix="mcpConfig" showDescription={false} />
      <MCPServerAccordion
        isLoading={isLoading}
        onToolsDiscovered={handleToolsDiscovered}
        onTestStart={handleTestStart}
      />
      <MCPToolsAccordion isLoading={isLoading} discoveredTools={localDiscoveredTools} />
      {activationSettings && (
        <CampaignActivationAccordion activationSettings={activationSettings} />
      )}
    </>
  )
}
